import React, { useState } from "react";
import Button from "../button/button.component";
import { ToastContainer, toast } from "react-toastify";
import emailjs from "@emailjs/browser";

const ContactUs = () => {
  const serviceID = process.env.REACT_APP_SERVICE_ID;
  const templateID = process.env.REACT_APP_TEMPLATE_ID;

  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    companyname: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      formData.fullname === "" ||
      formData.email === "" ||
      formData.subject === "" ||
      formData.message === ""
    ) {
      toast.error("Please fill all the required fields", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      return;
    } else {
      setIsLoading(true);
      emailjs
        .send(serviceID, templateID, {
          to_name: "YTC",
          from_name: formData.email,
          message: `
          Name: ${formData.fullname},
          Email: ${formData.email},
          Company Name: ${formData?.companyname ? formData.companyname : "N/A"},
          Subject: ${formData.subject},
          Message: ${formData.message}`,
        })
        .then(
          function () {
            setFormData({
              fullname: "",
              email: "",
              companyname: "",
              subject: "",
              message: "",
            });
            toast.success(
              "Thank you for contacting us. We will get back to you soon.",
              {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
              }
            );
          },
          function () {
            toast.error("Some thing went Wrong!!", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "dark",
            });
          }
        );
    }
    setIsLoading(false);
  };

  return (
    <div
      className="py-8 lg:py-32 w-full text-white flex justify-center px-4 lg:px-0 bg-primaryBg back drop-blur-2xl"
      id="contact"
    >
      <div className="max-w-7xl flex w-full flex-col gap-4 lg:gap-8 rounded-xl p-2 lg:p-8">
        <h2
          className="text-2xl lg:text-4xl font-bold px-3"
          data-aos="fade-up"
          data-aos-duration={1000}
          data-aos-delay={400}
        >
          Let's discuss your idea!
        </h2>
        <div className="flex justify-center lg:justify-between isolate">
        <div
          className="relative flex w-full before:absolute before:h-28 before:top-1/4 before:w-full before:blur-3xl before:bg-[#433287] before:-z-10 after:absolute after:h-28 after:w-full after:blur-3xl after:bg-[#3d3464] after:-z-10 after:top-3/4"
        >
          <form
            data-aos="fade-up"
            data-aos-duration={1000}
            data-aos-delay={600}
            onSubmit={handleSubmit}
            className="w-full max-w-xl bg-white/0 backdrop-blur-2xl border border-[#a0a5e2] p-3 lg:p-8 shadow-md rounded-lg lg:rounded-xl"
          >
            <div className="py-2">
              <label
                htmlFor="fullname"
                className="block text-sm lg:text-lg font-medium"
              >
                Full Name*
              </label>
              <input
                type="text"
                id="fullname"
                name="fullname"
                value={formData.fullname}
                onChange={handleChange}
                className="mt-1 p-2 w-full border rounded lg:rounded-md border-[#a0a5e2] focus-visible:border-none bg-transparent"
                required
              />
            </div>

            <div className="py-2">
              <label
                htmlFor="email"
                className="block text-sm lg:text-lg font-medium"
              >
                Email*
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="mt-1 p-2 w-full border rounded lg:rounded-md border-[#a0a5e2] focus-visible:border-none bg-transparent"
                required
              />
            </div>

            <div className="py-2">
              <label
                htmlFor="companyname"
                className="block text-sm lg:text-lg font-medium"
              >
                Company Name ( Optional )
              </label>
              <input
                type="text"
                id="companyname"
                name="companyname"
                value={formData.companyname}
                onChange={handleChange}
                className="mt-1 p-2 w-full border rounded lg:rounded-md border-[#a0a5e2] focus-visible:border-none bg-transparent"
              />
            </div>

            <div className="py-2">
              <label
                htmlFor="subject"
                className="block text-sm lg:text-lg font-medium"
              >
                Subject*
              </label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                className="mt-1 p-2 w-full border rounded lg:rounded-md border-[#a0a5e2] focus-visible:border-none bg-transparent"
                required
              />
            </div>

            <div className="py-2">
              <label
                htmlFor="message"
                className="block text-sm lg:text-lg font-medium"
              >
                Message*
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="4"
                className="mt-1 p-2 w-full border rounded lg:rounded-md border-[#a0a5e2] focus-visible:border-none bg-transparent"
                required
              ></textarea>
            </div>

            <div className="flex items-center w-28">
              <Button
                type="submit"
                className="bg-dark-green hover:bg-light-green text-white rounded-md px-4 py-2 w-full"
              >
                {isLoading ? (
                  <div className="flex items-center justify-center w-full py-1">
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                  </div>
                ) : (
                  "Submit"
                )}
              </Button>
            </div>
          </form>
          </div>
          <div
            className="h-full w-full hidden lg:flex justify-center items-center"
            data-aos="fade-up"
            data-aos-duration={1000}
            data-aos-delay={600}
          >
            <img
              src="https://cdni.iconscout.com/illustration/premium/thumb/data-recovery-9773421-7973944.png"
              alt="contact-us"
              className="bg-cover"
            />
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default ContactUs;
